module.exports = __webpack_public_path__ + "img/D64480_E27497_EA9BB1_CD156F-256px.5ac23848.png";